import { fmtMin, fmtTime } from "@/lib/format";
import { StatusBadge } from "@/components/common";

export function OrderTasksTable({ tasks }) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-x-auto">
      <h2 className="text-xl font-bold uppercase tracking-tight px-5 pt-4">Tasks</h2>
      <table className="w-full text-sm mt-2" data-testid="order-tasks-table">
        <thead>
          <tr className="border-b border-border text-left">
            {["Task", "Type", "Workers", "Start", "End", "Active", "Qty", "Short/Dmg/Rej", "Status", "Verified"].map((h) => (
              <th key={h} className="px-4 py-2 text-[10px] font-mono uppercase tracking-widest text-muted-foreground whitespace-nowrap">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(tasks || []).map((t) => (
            <tr key={t.task_id} className="border-b border-border/50">
              <td className="px-4 py-2.5 metric text-primary">{t.task_id}</td>
              <td className="px-4 py-2.5 capitalize">{t.type}</td>
              <td className="px-4 py-2.5">{(t.assigned_to_names || []).join(", ") || "unassigned"}</td>
              <td className="px-4 py-2.5 metric text-xs">{fmtTime(t.start_time)}</td>
              <td className="px-4 py-2.5 metric text-xs">{fmtTime(t.end_time)}</td>
              <td className="px-4 py-2.5 metric">{fmtMin(t.active_minutes)}</td>
              <td className="px-4 py-2.5 metric">{t.quantity?.toLocaleString() ?? "—"}</td>
              <td className="px-4 py-2.5 metric text-xs">{[t.short_qty, t.damage_qty, t.rejected_qty].some((v) => v) ? `${t.short_qty || 0}/${t.damage_qty || 0}/${t.rejected_qty || 0}` : "—"}</td>
              <td className="px-4 py-2.5"><StatusBadge status={t.status} /></td>
              <td className="px-4 py-2.5 text-xs text-signal-green">{t.verified_by || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
